import React, { useState } from 'react';
import c from 'classnames';

export const RADIO_TAB_ACTIVE_CLASS = 'pricewell-active-frequency';
export const RADIO_TAB_ACTIVE_CSS = `bg-green-500 text-white ${RADIO_TAB_ACTIVE_CLASS}`;

export interface RadioTabItem {
    id: string;
    label: string;
    value: string;
}

export interface RadioTabsProps {
    name: string;
    items: RadioTabItem[];
    onChange: (value: string) => void;
    value: string;
}

export default function RadioTabs({ name, items, value, onChange }: RadioTabsProps) {
    const [selectedItem, setSelectedItem] = useState(value);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.currentTarget.checked) {
            setSelectedItem(e.currentTarget.value);
            onChange(e.currentTarget.value);
        }
    };

    return (
        <div
            className="
                          inline-flex
                          p-1
                          pr-0
                          bg-gray-200
                          rounded-full
                          overflow-hidden
                      "
        >
            {items.map((item) => (
                <label
                    key={item.id}
                    htmlFor={item.id}
                    className={c(
                        'block px-4 py-1 rounded-full cursor-pointer hover:bg-gray-400 hover:text-white mr-1 pricewell-frequency',
                        selectedItem === item.value ? RADIO_TAB_ACTIVE_CSS : ''
                    )}
                >
                    <input
                        type="radio"
                        className="hidden"
                        id={item.id}
                        value={item.value}
                        name={name}
                        onChange={handleChange}
                    />
                    <div>{item.label}</div>
                </label>
            ))}
        </div>
    );
}
